
import { useEffect } from 'react';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import BlogHero from './components/BlogHero';
import BlogContent from './components/BlogContent';

export default function BlogComplexLayouts() {
  useEffect(() => {
    // Update page title
    document.title =
      'How to Manage Complex Formwork Layouts in Vancouver High-Density Projects | Dinari Designs';

    // Update meta description safely
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        'content',
        'Urban density in the Lower Mainland means smaller lots and more complex slab designs. Learn how AutoCAD helps navigate tight tolerances and intricate geometries in high-density construction Vancouver projects.'
      );
    }

    // Update meta keywords safely
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute(
        'content',
        'high-density construction Vancouver, complex formwork layouts, structural coordination BC, AutoCAD formwork design, clash detection construction'
      );
    }

    // Create JSON‑LD script for SEO
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'Article',
      // Use double quotes to avoid escaping the apostrophe
      headline: "How to Manage Complex Formwork Layouts in Vancouver's High-Density Projects",
      description:
        'Urban density in the Lower Mainland means smaller lots and more complex slab designs. Learn how AutoCAD helps navigate tight tolerances and intricate geometries.',
      author: {
        '@type': 'Organization',
        name: 'Dinari Designs',
      },
      publisher: {
        '@type': 'Organization',
        name: 'Dinari Designs',
        logo: {
          '@type': 'ImageObject',
          url: 'https://static.readdy.ai/image/f0c3f25d25166b296c2998ed1e07db56/4ed16d38f79ad8245b8fcfc88558374a.jfif',
        },
      },
      datePublished: '2024-05-15',
      // Ensure a valid ISO date string (YYYY‑MM‑DD)
      dateModified: new Date().toISOString().split('T')[0],
    });

    // Append only once
    if (!document.head.querySelector('script[data-schema="blog-complex"]')) {
      script.setAttribute('data-schema', 'blog-complex');
      document.head.appendChild(script);
    }

    // Cleanup on unmount
    return () => {
      const schemaScript = document.head.querySelector(
        'script[data-schema="blog-complex"]'
      );
      if (schemaScript) {
        schemaScript.remove();
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <BlogHero />
      <BlogContent />
      <Footer />
    </div>
  );
}
